import { storage } from "@source-digital/experience-utils";
const storagePrefix = "sd-analytics-utm__";
const analyticsStorage = storage.createLocalStorage({ prefix: storagePrefix });
function loadUtmParams() {
  const utmParams = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: utmParams.get("utm_source"),
    utm_medium: utmParams.get("utm_medium"),
    utm_campaign: utmParams.get("utm_campaign"),
    utm_term: utmParams.get("utm_term"),
    utm_content: utmParams.get("utm_content")
  };
  if (Object.values(utm).every((v) => v == null)) {
    return analyticsStorage.get("utm") ?? {};
  }
  analyticsStorage.set("utm", utm);
  return utm;
}
export {
  loadUtmParams
};
